/* eslint-disable camelcase */
import Axios from 'axios'
import globalConfig from '../config'

export const artistService = {
  getOneArtist: async (idArtist) => {
    const { data } = await Axios.get(`${globalConfig.url}/artists/${idArtist}`)
    return data
  },
  getAllArtists: async () => {
    const { data } = await Axios.get(`${globalConfig.url}/artists`)
    return data
  }
}
